import React, { useState } from 'react';
import { HelpCircle, Mail, Copy, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';
import SupportEmailPopup from '../components/SupportEmailPopup';

const SupportTickets = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const email = 'support@razientsounds.com';

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      toast.success('Email copied!');
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="min-h-screen relative pt-20">
      <div className="container mx-auto px-4 py-8 relative z-10 max-w-2xl">
        <div className="text-center mb-8">
          <HelpCircle size={56} className="mx-auto mb-4 text-violet-400" />
          <h1 className="text-4xl font-bold gradient-text mb-3">Support</h1>
          <p className="text-white/60 text-lg">Need help? Reach out to our team</p>
        </div>

        <Card className="glass-default border-white/10" data-testid="support-card">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-violet-500/20 flex items-center justify-center mx-auto mb-5">
              <Mail className="w-8 h-8 text-violet-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">Email Us</h2>
            <p className="text-white/50 mb-6">Send us an email and we'll get back to you shortly</p>

            <div
              className="relative rounded-xl p-5 mb-5"
              style={{
                background: 'rgba(168, 85, 247, 0.08)',
                border: '1px solid rgba(168, 85, 247, 0.25)',
                boxShadow: '0 0 20px rgba(168, 85, 247, 0.15)'
              }}
            >
              <p
                className="text-xl font-semibold tracking-wide"
                style={{
                  color: '#c084fc',
                  textShadow: '0 0 10px rgba(192, 132, 252, 0.6), 0 0 20px rgba(168, 85, 247, 0.4)'
                }}
                data-testid="support-email-display"
              >
                {email}
              </p>
            </div>

            <Button
              onClick={handleCopy}
              data-testid="copy-support-email"
              className={`w-full h-12 rounded-full font-semibold transition-all duration-300 ${
                copied
                  ? 'bg-green-600 hover:bg-green-500'
                  : 'bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-500 hover:to-indigo-500 shadow-[0_0_20px_rgba(139,92,246,0.4)]'
              }`}
            >
              {copied ? <><Check className="mr-2" size={18} /> Copied!</> : <><Copy className="mr-2" size={18} /> Copy Email Address</>}
            </Button>

            <p className="text-white/40 text-sm mt-4">We typically respond within 24 hours</p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SupportTickets;
